/// <amd-module name="TFS/Diag/ActionsMonitor/ActionMonitor" />
import * as React from "react";
import { Components } from "VSS/Platform/Layout";
import { ActionEventListener } from "./ActionEventListener";
import { ActionMonitorPane } from "./ActionMonitorPane";
import { ActionMonitorStore, IActionRecord } from "./ActionMonitorStore";

export interface IActionMonitorState {
    firedActions: IActionRecord[];
    isPaneOpen: boolean;
}

export class ActionMonitor extends React.Component<{}, IActionMonitorState> {
    private _actionEventListener: ActionEventListener | null;
    private _actionMonitorStore: ActionMonitorStore;

    constructor(props: {}) {
        super(props);
        this.state = { firedActions: [], isPaneOpen: false };
        this._actionMonitorStore = new ActionMonitorStore(this._onStoreChanged);
        this._actionEventListener = new ActionEventListener(this._actionMonitorStore);
    }

    public render(): JSX.Element {
        const { firedActions } = this.state;

        return (
            <div className="perf-section actionable">
                <div onClick={this._openPane}>{firedActions.length} Actions Invoked</div>
                {this._renderPane()}
            </div>
        );
    }

    public componentWillUnmount(): void {
        if (this._actionEventListener) {
            this._actionEventListener.dispose();
            this._actionEventListener = null;
        }
    }

    private _renderPane(): JSX.Element | undefined {
        const { firedActions, isPaneOpen } = this.state;

        if (isPaneOpen) {
            return (
                <ActionMonitorPane
                    firedActions={firedActions}
                    onClearActionRecord={this._onClearActionRecord}
                    onClearHistory={this._onClearHistory}
                    onDismiss={this._closePane}
                />
            );
        }
    }

    private _onClearHistory = () => {
        this._actionMonitorStore.clearActionRecords();
    };

    private _onClearActionRecord = (index: number) => {
        this._actionMonitorStore.clearActionRecord(index);
    };

    private _onStoreChanged = () => {
        this.setState({
            firedActions: this._actionMonitorStore.firedActions
        });
    };

    private _openPane = () => {
        this.setState({ isPaneOpen: true });
    };

    private _closePane = () => {
        this.setState({ isPaneOpen: false });
    };
}

Components.add("perfbar.actionMonitor", ActionMonitor);
